<style scoped lang="scss">
    .reply {
        .owner-name {
            font-size: 1.1em;
            font-weight: bold;
        }
    }

    .reply-container {
        background-color: #eee;
        padding: 20px;
        textarea {
            background-color: #fff;
        }
    }

    .white-text {
      color: white;
    }
</style>

<template>
    <div>
        <div class="uk-grid" v-if="message && user">
            <div class="uk-width-8-10 uk-align-center">
                <a href="javascript:;" @click="$router.replace('/inbox')">
                    <i class="uk-icon-backward"></i>
                    Back to All Messages
                </a>
            </div>

            <div class="uk-width-8-10 uk-align-center">
                <h3 class="communication-direction-text uk-text-lead uk-text-center">
                <span class="uk-float-left">
                    MESSAGE #{{ message.id }}
                </span>
                </h3>
            </div>
            <hr class="uk-width-8-10 uk-align-center dashed-hr uk-margin-bottom"/>

            <div class="uk-width-8-10 uk-align-center uk-grid uk-padding-remove">
                <div class="uk-width-medium-1-3 uk-width-small-1-1 communication-type-and-who">
                    <span class=" communication-item-date-time">
                        <span class="uk-text-muted">Date:</span>  <br>
                        {{ message.created_at | moment('MM/DD/YYYY h:m a')}}
                    </span>
                </div>
                <br class="print-only">
                <div class="uk-width-medium-1-3 uk-width-small-1-1 communication-item-excerpt uk-margin-bottom">
                    <span class="uk-text-muted">From: </span> <br>
                    {{ message.owner.name | obscuredName }}
                </div>
                <br class="print-only">
                <div class="uk-width-medium-1-3 uk-width-small-1-1 communication-item-tt-to-from">
                    <span class="uk-text-muted">To: </span> <br>
                    <span v-for="recipient in message.recipients">
                        {{ recipient.user.name | obscuredName }}
                        <i
                            :class="{'a-envelope-4': !isRead, 'a-envelope-open_1': isRead}"
                            uk-tooltip="pos:top-left;title:Not viewed yet"
                            title="" aria-expanded="false"></i>,
                    </span>
                </div>
            </div>

            <div class="uk-width-medium-8-10 uk-align-center uk-grid uk-padding-remove uk-margin-top-remove">

                <div class="uk-width-1-1"><!--used to be uk-width-9-10, but Linda changed it-->
                    <div uk-grid="" class="uk-grid-collapse uk-grid">
                        <div class="uk-width-1-6 uk-margin-bottom">
                            <span class="uk-text-muted">Subject: </span>
                        </div>
                        <div class="uk-width-5-6 uk-text-left uk-margin-bottom">
                            <strong>{{ message.subject }}</strong><br>
                        </div>
                        <br class="print-only">
                        <div class="uk-width-1-6 uk-margin-bottom">
                            <span class="uk-text-muted">Message: </span>
                        </div>
                        <div class="uk-width-5-6">
                            <div><p>{{ message.message }}</p></div>
                        </div>
                    </div>
                </div>

                <div class="uk-width-1-1 uk-margin-top" v-if="message.local_documents.length">
                  <h4>Attachments</h4>
                  <table class="uk-table uk-table-striped">
                    <thead>
                    <tr>
                      <th>Filename</th>
                      <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="doc in message.local_documents">
                      <td>{{ doc.filename }}</td>
                      <td>
                        <a :href="`/download-local-document/${doc.id}`" target="_blank">
                          <i class="uk-icon-download"></i>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

            </div>

            <hr class="uk-width-8-10 uk-align-center dashed-hr uk-margin-bottom" />
            <div class="uk-width-8-10 uk-align-center">
                <h3 class="communication-direction-text uk-text-lead uk-text-center">
                        <span class="uk-float-left" v-if="message.replies.length > 0">
                            REPLIES ({{ message.replies.length }})
                        </span>
                        <span class="uk-float-left" v-else>
                            NO REPLIES
                        </span>
                </h3>
            </div>
            <div class="uk-margin-top uk-width-8-10 uk-align-center" v-if="message && user">
                <div v-for="reply in message.replies"
                     class="reply uk-width-1-1 communication-list-item normal-cursor uk-margin-large-bottom">
                    <div uk-grid="" class="communication-summary uk-grid">
                        <div class="uk-width-medium-1-5 uk-width-small-1-1 communication-type-and-who">
                            <span class="owner-name">{{ reply.owner.name | obscuredName }}<br></span>
                            <span class=" communication-item-date-time">
                            {{ reply.created_at | moment('MM/DD/YYYY h:m a')}}
                        </span>
                        </div>
                        <div class="uk-width-medium-4-5 uk-width-small-1-1 communication-item-excerpt">
                            <p>{{ reply.message }}</p>
                        </div>
                        <div class="uk-width-1-1 uk-width-2-5@s"></div>
                      <div class="uk-width-1-1 uk-margin-top" v-if="reply.local_documents && reply.local_documents.length">
                        <h4>Attachments</h4>
                        <table class="uk-table uk-table-striped">
                          <thead>
                          <tr>
                            <th>Filename</th>
                            <th>&nbsp;</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="doc in reply.local_documents">
                            <td>{{ doc.filename }}</td>
                            <td>
                              <a :href="`/download-local-document/${doc.id}`" target="_blank">
                                <i class="uk-icon-download"></i>
                              </a>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                        <hr class="print-only">
                    </div>
                </div>
            </div>
            <hr class="uk-width-8-10 uk-align-center dashed-hr" />
            <div class="uk-width-8-10 uk-align-center reply-container" >
                <form @submit.stop="submitReply" class="uk-form uk-form-horizontal">
                    <div class="uk-form-row">
                        <label class="uk-form-label">Reply</label>
                        <div class="uk-form-controls">
                          <textarea class="uk-width-1-1 uk-input"
                                    v-model="replyBody"
                                    placeholder="Add your reply here..."></textarea>
                        </div>
                    </div>
                    <template v-if="showFileForm">
                      <p>{{ message.owner.name | obscuredName }} has requested that you upload one or more documents. Please provide the requested items below.</p>
                      <div class="file-upload-wrapper uk-margin-top">
                        <vue-dropzone
                            ref="dropzoneUpload"
                            :options="dropzoneOptions"
                            :useCustomSlot=true
                            v-on:vdropzone-sending="sendingFile"
                            v-on:vdropzone-max-files-exceeded="onMaxFilesExceeded"
                            v-on:vdropzone-success="onFileUpdated"
                        >
                          <div class="dropzone-custom-content file-dropzone">
                            <p class="dropzone-custom-title">Drop File Here or Click to Select a File!</p>
                          </div>
                        </vue-dropzone>
                      </div>
                      <div class="uk-width-1-1 uk-margin-large-top" v-if="documents.length">
                        <table class="uk-table gray-link-table">
                          <thead>
                          <tr class="uk-text-small" style="background-color:#555;">
                            <th class="white-text"><span class="uk-margin-small-left">NAME</span></th>
                            <th class="white-text" style="width: 150px;">ACTIONS</th>
                          </tr>
                          </thead>
                          <tbody style="font-size: 13px">
                          <tr :class="`document-row document-row-${doc.id}`" v-for="(doc, key) in documents" :key="key">
                            <td>{{ doc.filename }}</td>
                            <td>
                              <a :href="`/applicant/download-local-document/${doc.id}`" target="_blank" uk-tooltip="Download File" title="" aria-expanded="false">
                                <i class="a-lower"></i>
                              </a> &nbsp;|&nbsp;
                              <a href="javscript:;" @click="previewFile(doc)" uk-tooltip="Preview File" title="" aria-expanded="false">
                                <i class="a-file-search"></i>
                              </a> &nbsp;|&nbsp;
                              <a href="javascript:;" class="uk-button uk-button-danger uk-margin-left" @click="deleteDocument(key, doc)"><i class="fa fa-trash"></i></a>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </template>
                    <div v-for="error in formErrors" class="uk-text-danger">
                      {{ error }}
                    </div>
                    <div class="uk-form-row uk-margin-top">
                        <button class="uk-button uk-button-primary uk-align-right">Submit Reply</button>
                    </div>
                </form>

            </div>
        </div>
      <preview-document-modal ref="previewModal"></preview-document-modal>
    </div>

</template>

<script>
    import MessageListItem from "../../components/Messages/MessageListItem";
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import PreviewDocumentModal from "../../../dashboard/pages/Documents/PreviewDocumentModal.vue";
    export default {
        name: "MessageDetails",
        components: {
          PreviewDocumentModal,
          MessageListItem,
          vueDropzone: vue2Dropzone,
        },
        props: {
            id: {
                default: null,
            },
            highlightReply: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                message: null,
                user: {},
                replyBody: '',
                replyLoading: false,
                formErrors: null,
                documents: [],
                dropzoneOptions: {
                  url: `/api/hope/documents`,
                  thumbnailWidth: 200,
                  addRemoveLinks: true,
                  maxFiles: 1,
                  acceptedFiles: ['.pdf', '.png', '.jpg', '.jpeg'].join(','),
                },
            }
        },
        computed: {
            isRead() {
                let isRead = false;
                if(this.message.owner_id === this.user.id) {
                    isRead = true;
                };
                for(var i in this.message.recipients) {
                    if(this.message.recipients[i].user_id === this.user.id && this.message.recipients[i].seen_at !== null) {
                        isRead = true;
                    };
                }

                // Check Replies
                _.each(this.message.replies, reply => {
                    _.each(reply.recipients, recipient => {
                        if(recipient.user_id == this.user.id && recipient.seen_at === null) {
                            isRead = false;
                        }
                    })
                })

                return isRead;
            },
            showFileForm() {
              return this.message.open_doc_request;
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
          getData() {
              axios.get('/api/hope/me').then(r => {
                  this.user = r.data.user;
              })
              axios.get('/api/hope/communications/'+this.id).then(r => {
                  this.message = r.data.communication;
              })
          },
          onMessageUpdated($event) {

          },
          submitReply($event) {
              this.replyLoading = true;
              axios.post(`/api/hope/communications/${this.id}/reply`, {
                  message: this.replyBody,
                  documents: this.documents,
              })
                  .then(r => {
                      this.replyLoading = false;
                      this.replyBody = '';
                      this.getData();
                  })
                  .catch(err => {
                      console.log(err.response.data)
                      this.replyLoading = false;
                      this.formErrors = err.response.data.errors;
                  })
          },

          sendingFile(file, xhr, formData) {
            formData.append('application_id', this.message.household_application_id);
            formData.append('type', 'communication');
          },

          onMaxFilesExceeded(file) {
            this.$refs.dropzoneUpload.removeAllFiles();
            this.$refs.dropzoneUpload.manuallyAddFile(file);
          },

          onFileUpdated() {
            const newDocs = this.getDocuments();
            if (newDocs && newDocs.length)
              this.documents.push(newDocs[0]);

            this.$refs.dropzoneUpload.removeAllFiles();
          },

          previewFile(document) {
            let url =`/api/hope/documents/${document.id}/preview`;
            this.$refs.previewModal.open(url, document);
          },

          deleteDocument(index, doc) {
            UIkit.modal.confirm('Are you sure your want to delete this file?').then(() => {
              this.$store
                  .dispatch('Document/deleteDocument', doc.id)
                  .then((res) => {
                    this.message.local_documents.splice(index, 1);
                  })
                  .catch((err) => {
                  })
            }, () => {
            });
          },

          getDocuments() {
            const orgFiles = this.$refs.dropzoneUpload.getAcceptedFiles()
            return this._getDocumentIdsFromOrgFiles(orgFiles);
          },

          _getDocumentIdsFromOrgFiles(files) {
            if (files && files.length)
            {
              const res = JSON.parse(files[0].xhr.response);
              return [res.document]
            }
            return []
          },
        }
    }
</script>
